import { RefObject, useCallback, useState } from "react";
import { flushSync } from "react-dom";
import { Company } from "../../../setups/types/setupTypes";
import { Employee } from "../../types/processTypes";
import {
  buildAndSavePdfFromDom,
  buildBulkCvFileName,
} from "../utils/buildCvPdf";

function waitForPaint(): Promise<void> {
  return new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
  });
}

export function useBulkOfficePdfDownload(
  hiddenRootRef: RefObject<HTMLElement | null>,
) {
  const [pdfTarget, setPdfTarget] = useState<Company | null>(null);
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadBulk = useCallback(
    async (offices: Company[], employee: Employee) => {
      if (!employee.givenName || offices.length === 0) return;

      setIsDownloading(true);
      try {
        for (const office of offices) {
          flushSync(() => setPdfTarget(office));
          await waitForPaint();

          const numberOfPages = office.cvTemplate?.numberOfPages ?? 1;
          await buildAndSavePdfFromDom(
            buildBulkCvFileName(employee, office),
            numberOfPages,
            hiddenRootRef.current,
          );
        }
      } finally {
        flushSync(() => setPdfTarget(null));
        setIsDownloading(false);
      }
    },
    [hiddenRootRef],
  );

  return { pdfTarget, downloadBulk, isDownloading };
}
